export default {
  vapidKey: process.env.VUE_APP_MESSAGING_VAPID_KEY
}
